const prosZones = {
  ATB_PAGE: {
    ATBPage_ZONE_C: 'ATBPage_ZONE_C',
    ATBPage_ZONE_E: 'ATBPage_ZONE_E',
  },
  BAG_PAGE: {
    SB_ZONE_A: 'SB_ZONE_A',
    SB_ZONE_B: 'SB_ZONE_B',
    SB_ZONE_C: 'SB_ZONE_C',
  },
  BROWSE_PAGE: {
    BROWSE_ZONE_A: 'BROWSE_ZONE_A',
    BROWSE_ZONE_B: 'BROWSE_ZONE_B',
    BROWSE_ZONE_C: 'BROWSE_ZONE_C',
    BROWSE_ZONE_D: 'BROWSE_ZONE_D',
    BROWSE_ZONE_E: 'BROWSE_ZONE_E',
    BROWSE_ZONE_F: 'BROWSE_ZONE_F',
    BROWSE_ZONE_G: 'BROWSE_ZONE_G',
  },
  CAT_SPLASH_PAGE: {
    C2FLEX_ZONE_A: 'C2FLEX_ZONE_A',
    C2FLEX_ZONE_B: 'C2FLEX_ZONE_B',
    C2FLEX_ZONE_C: 'C2FLEX_ZONE_C',
    C2FLEX_ZONE_D: 'C2FLEX_ZONE_D',
  },
  HOME_PAGE: {
    HP_ZONE_B: 'HP_ZONE_B',
    HP_ZONE_C: 'HP_ZONE_C',
    HP_ZONE_D: 'HP_ZONE_D',
    HP_ZONE_E: 'HP_ZONE_E',
    HP_ZONE_F: 'HP_ZONE_F',
    HP_ZONE_K: 'HP_ZONE_K',
    HP_ZONE_L: 'HP_ZONE_L',
    HP_ZONE_M: 'HP_ZONE_M',
    product_pool_zone: 'product_pool_zone',
  },
  MLT_PAGE: {
    MLT_ZONE_A: 'MLTPage_ZONE_A',
  },
  MY_ACCOUNT_PAGE: {
    MAP_ZONE_A: 'MAP_ZONE_A',
  },
  ORDER_CONFIRMATION_PAGE: {
    OCP_ZONE_A: 'OCP_ZONE_A',
  },
  ORDER_HISTORY_PAGE: {
    OH_ZONE_A: 'OH_ZONE_A',
  },
  PDP_PAGE: {
    PDP_ZONE_A: 'PDP_ZONE_A',
    PDP_ZONE_B: 'PDP_ZONE_B',
    PDP_ZONE_C: 'PDP_ZONE_C',
    PDP_ZONE_F: 'PDP_ZONE_F',
    PDP_ZONE_G: 'PDP_ZONE_G',
    PDP_ZONE_H: 'PDP_ZONE_H',
    PDP_ZONE_I: 'PDP_ZONE_I',
    RVI_PDP: 'RVI_PDP',
    rvi_pdp_zone: 'rvi_pdp_zone',
  },
  RETURN_CONFIRMATION_PAGE: {
    RCP_ZONE_A: 'RCP_ZONE_A',
  },
  SEARCH_PAGE: {
    SEARCH_ZONE_A: 'SEARCH_ZONE_A',
  },
  STORE_PURCHASE_DETAIL_PAGE: {
    SPD_ZONE_A: 'SPD_ZONE_A',
    SPD_ZONE_B: 'SPD_ZONE_B',
  },
  STORE_PURCHASE_HISTORY_PAGE: {
    SPH_ZONE_A: 'SPH_ZONE_A',
    SPH_ZONE_B: 'SPH_ZONE_B',
  },
  ZSR_PAGE: {
    ZSR_ZONE_B: 'ZSR_ZONE_B',
  },
};

export default prosZones;
